// extracted by mini-css-extract-plugin
module.exports = {"root":"intro-block_root__1M7zE","title":"intro-block_title__20QIP","tagline":"intro-block_tagline__2EwIM"};